import React, { useEffect, useRef, useState } from 'react'

const DoubleScrollbar = ({ children }) => {
  const [width, setWidth] = useState('auto')
  const childrenWrapper = useRef()
  const outerDiv = useRef()
  const innerDiv = useRef()

  useEffect(() => {
    if (childrenWrapper?.current && childrenWrapper?.current?.scrollWidth) {
      setWidth(childrenWrapper.current.scrollWidth + 'px')
    } else {
      setWidth('auto')
    }
  }, [childrenWrapper?.current?.scrollWidth])

  return (
    <div>
      <div
        ref={outerDiv}
        style={{ overflowX: 'auto', overflowY: 'hidden' }}
        onScroll={() => {
          if (!childrenWrapper?.current || !outerDiv?.current) return
          childrenWrapper.current.scrollLeft = outerDiv.current.scrollLeft
        }}
      >
        <div ref={innerDiv} style={{ paddingTop: '1px', width: width }}>
          &nbsp;
        </div>
      </div>
      <div
        ref={childrenWrapper}
        style={{ overflowX: 'auto', overflowY: 'hidden' }}
        onScroll={() => {
          if (!childrenWrapper?.current || !outerDiv?.current) return

          outerDiv.current.scrollLeft = childrenWrapper.current.scrollLeft
        }}
      >
        {children}
      </div>
    </div>
  )
}

export default DoubleScrollbar
